import { gql } from '../types/generated';

export const USER_ID = gql(`
  query userId($email: String!) {
    userInfo(email: $email) {
      id
    }
  }`);

export const USER_DATA = gql(`
  query userData($userId: String!, $startDate: String, $endDate: String, $page: Int, $size: Int) {
    userData(userId: $userId) {
      userId
      entitlements
      cachedEntitlements
      profile {
        favoriteTeam
        doNotSell
        email
        firstName
        lastName
      }
      cachedProfile {
        favoriteTeam
        doNotSell
      }
      sessions (startDate: $startDate, endDate: $endDate, page: $page, size: $size) {
        totalCount
        sessions {
          sessionId
          initTime
          location {
            zip
            country
            latitude
            longitude
            designatedMarketArea
            locationProvider
          }
          expireDate
          experience
          features
          playbackSessions {
              playbackSessionId
              createTime
              countsForCap
              mediaId
              entitlements
              playbackStatus
              contentExperience
              features
          }
          device {
            id
            os
            version
            platform
            ipAddress
            userAgent
            applicationRuntime
            language
            profile
            manufacturer
            model
            extraAttributes
            appVersion
          }
        }
      }
    }
  }`);
